// Libs
import classNames from 'classnames/bind';
import { Box, Grid2, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLoadScript } from '@react-google-maps/api';
import { useSelector } from 'react-redux';
// Components, Layouts, Pages
import { BaseLabelValueField, BaseMap, BaseStatus } from '~/components/common';
// Others
import { DEFAULT_GG_MAP_LOAD_SCRIPT_LIB, EMPTY_STRING } from '~/utils/constants/common';
import { googleMapApiKey } from '~/utils/constants/env';
import { convertMinuteToHours, formatDate, formatTime, getFullName } from '~/utils/helper/common';
import { ITimeClockDetail } from '~/utils/interface/timeClock';
import { DateFormatEnum, TimeFormatEnum } from '~/utils/enum/common';
import { selectTimeClockDetails } from '~/thunks/timeClock/timeClockSlice';
// Styles, images, icons
import styles from './TimeClockInformation.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const TimeClockInformation = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/timeClock']);
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: googleMapApiKey ?? EMPTY_STRING,
    libraries: DEFAULT_GG_MAP_LOAD_SCRIPT_LIB,
  });
  //#endregion Declare Hook

  //#region Selector
  const timeClockDetails: ITimeClockDetail = useSelector(selectTimeClockDetails);
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box component={'div'} id='timeClockInformationPage' className={cx('container')}>
      <Grid2 container spacing={'24px'}>
        <Grid2 size={6}>
          <BaseLabelValueField
            label={t('tab_information_name')}
            value={getFullName({ ...timeClockDetails?.account })}
          />

          <BaseLabelValueField
            label={t('tab_information_job_name')}
            value={timeClockDetails?.job?.name || EMPTY_STRING}
          />

          <BaseLabelValueField
            label={t('tab_information_date')}
            value={
              timeClockDetails?.date
                ? formatDate(timeClockDetails?.date, DateFormatEnum.DD_MMM_YYYY)
                : EMPTY_STRING
            }
          />

          <BaseLabelValueField
            label={t('tab_information_check_in')}
            value={
              timeClockDetails?.startTime
                ? formatTime(timeClockDetails?.startTime, TimeFormatEnum.HOUR_MINUTE_AM_PM)
                : EMPTY_STRING
            }
          />

          <BaseLabelValueField
            label={t('tab_information_check_out')}
            value={
              timeClockDetails?.endTime
                ? formatTime(timeClockDetails?.endTime, TimeFormatEnum.HOUR_MINUTE_AM_PM)
                : EMPTY_STRING
            }
          />

          <BaseLabelValueField
            label={t('tab_information_hours')}
            value={
              timeClockDetails?.duration
                ? convertMinuteToHours(Number(timeClockDetails?.duration))
                : EMPTY_STRING
            }
          />
          <BaseLabelValueField
            label={t('tab_information_status')}
            value={timeClockDetails?.status ? <BaseStatus label={timeClockDetails?.status} /> : EMPTY_STRING}
          />

          {/* <Box component={'div'} className={cx('timecard')}>
            <Tooltip
              title={t('tab_information_timecard')}
              placement='top-start'
              enterDelay={DEFAULT_TOOLTIP_DELAY}
              leaveDelay={DEFAULT_TOOLTIP_DELAY}
            >
              <Typography component={'div'} className={cx('timecardTitle')}>
                {t('tab_information_timecard')}
              </Typography>
            </Tooltip>

            <BaseTable
              columns={additionalContactsColumns(t)}
              dataSource={timeClockDetails?.timeDetails || []}
            />
          </Box> */}
        </Grid2>

        <Grid2 container direction={'column'} size={6} spacing={0}>
          <Stack className={cx('mapContainer')}>
            <BaseLabelValueField
              label={t('tab_information_location')}
              value={timeClockDetails?.location || EMPTY_STRING}
              bordered={false}
              labelSize={'auto'}
            />

            <Stack flex={1} className={cx('map')}>
              {isLoaded && (
                <BaseMap
                  {...(timeClockDetails?.latitude &&
                    timeClockDetails?.longitude && {
                      position: { lat: timeClockDetails?.latitude, lng: timeClockDetails?.longitude },
                    })}
                />
              )}
            </Stack>
          </Stack>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default TimeClockInformation;
